enum SubscriptionPlan {
  GO = "nuve_go",
  BASIC = "nuve_basic",
  PLUS = "nuve_plus",
  NETWORK = "nuve_network",
  CONNECT = "nuve_connect",
  SUPREME = "nuve_supreme",
  BASIC_OCT_2025 = "nuve_basic_oct_2025",
  BASIC_MAY_2025 = "nuve_basic_may_2025",
  PLUS_MAY_2025 = "nuve_plus_may_2025",
  E_PLUS = "nuve_e_plus",
  GROWTH = "nuve_growth",
}

export default SubscriptionPlan
